<template>
  <public-page :hideTopNav="true">
    <div class="separation-anxiety-exercise">
      <separation-anxiety-exercise-card />
    </div>
  </public-page>
</template>

<script>
import PublicPage from './PublicPage'
import SeparationAnxietyExerciseCard from '../cards/SeparationAnxietyExerciseCard.vue'

export default {
  name: 'separation-anxiety-exercise',
  components: {
    PublicPage,
    SeparationAnxietyExerciseCard,
  },
}
</script>

<style lang="scss">
</style>
